/**
 * Auto Title Case input handler.
 * Capitalizes the first letter of every word as user types.
 * If user holds Shift, typed letter stays uppercase (natural behavior).
 * Works by transforming the input value on change.
 */
export function toTitleCase(str) {
  if (!str) return str;
  return str.replace(/\b\w/g, (char) => char.toUpperCase());
}

/**
 * Creates an onChange handler that auto-title-cases the input value.
 * Usage: <Input onChange={titleCaseHandler((val) => setName(val))} />
 */
export function titleCaseHandler(setter) {
  return (e) => {
    const val = e.target.value;
    const titleCased = toTitleCase(val);
    setter(titleCased);
  };
}
